import React, { useEffect } from 'react';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import { useState, createState, Downgraded } from '@hookstate/core';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import { Box, FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import validator from 'validator';

const useStyles = makeStyles({
    dialogContentRoot: {
        // maxHeight: 400,
        // overflowY: 'hidden',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
        },
    },
});

const roleState = createState({
    roleID: 0,
    roleName: '',
    eventID: 0,
    status: 1,
    createdBy: 0,
});

const RoleDialog = (props) =>
{
    const classes = useStyles();
    const state = useState(roleState);
    const userInfo = useState(null);
    const eventInfo = useState(null);
    const isDisable = useState(false);
    // const roleStatus = useState(null);
    const eventRoleInfo = useState(null);
    const roleNameErr = useState('');
    // const roleID = useState(null);
    // const roleName = useState(null);
    // const createdBy = useState(null);
    const allRoles = useState(null);
    const [disableBtn, setDisableBtn] = React.useState(true);
    useEffect(() =>
    {
        //state.roleName.set('');
        const guserInfo = Helper.getStorage('userInfo');
        const geventInfo = Helper.getStorage('eventInfo');
        if (userInfo.get() == null)
        {
            state.eventID.set(geventInfo.eventID);
            state.createdBy.set(guserInfo.userID);
            userInfo.set(guserInfo);
            eventInfo.set(geventInfo);
        }
        if (props.eventRoleInfo && eventRoleInfo.get() == null)
        {
            state.set({ ...props.eventRoleInfo });
        }
        if (props.allRoles)
        {
            allRoles.set(props.allRoles);
        }
    }, []);

    const validateRole = (input) =>
    {
        if (validator.isAlphanumeric(input, 'en-US', { ignore: ' -' }))
            return true;
        else return false;
    };

    const renderDialogContent = () =>
    {
        const add = props.addButton;
        return (
            <>
                <TextField
                    required
                    autoComplete="off"
                    sx={{ width: '100%' }}
                    size="small"
                    id="outlined-required"
                    label="Role Name"
                    value={state.roleName.get()}
                    onChange={(event) =>
                    {
                        let str = event.target.value;
                        str = str.replace(/^\s+/g, '');
                        state.roleName.set(str);
                        //validateRole(str);
                        handleDisableBtn();
                    }}
                    inputProps={{ maxLength: 50 }}
                    error={roleNameErr.get().length > 0 ? true : false}
                    helperText={roleNameErr.get()}
                />
                {!add ? (
                    <Box sx={{ mt: 2, mb: 1 }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                                Status
                            </InputLabel>
                            <Select
                                size="small"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={state.status.get()}
                                label="Status"
                                onChange={(event) =>
                                {
                                    state.status.set(event.target.value);
                                    handleDisableBtn()
                                }
                                }>
                                <MenuItem value={1}>Active</MenuItem>
                                <MenuItem value={0}>Inactive</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                ) : null}
            </>
        );
    };

    const renderDialogActions = () =>
    {
        const add = props.addButton;
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={resetState}
                buttonText={add ? 'Create' : 'Update'}
                disableButton={isDisable.get()}
                disableUpdateButton={add > 0 ? false : disableBtn}

            />
        );
    };
    const handleDisableBtn = () =>
    {
        if (props.eventRoleInfo)
        {
            const data = props.eventRoleInfo
            const prevData = {
                roleName: data.roleName,
                status: data.status

            }
            const currentData = {
                roleName: state.get().roleName,
                status: state.get().status

            };
            if (JSON.stringify(prevData) === JSON.stringify(currentData))
            {
                setDisableBtn(true)
            } else
            {
                setDisableBtn(false)
            }
        }
    }
    const handleClick = () =>
    {
        if (!validateRole(state.roleName.get()))
        {
            roleNameErr.set('Please enter role name');
            return false;
        }

        if (allRoles.get())
        {
            let findInd = allRoles
                .attach(Downgraded)
                .get()
                .findIndex(
                    (item) =>
                        item.actualData.roleName.toLowerCase() ==
                        state.roleName.get().toLowerCase() &&
                        item.actualData.roleID != state.roleID.get()
                    // item.roleID != requestObj.roleID
                );

            if (findInd >= 0)
            {
                roleNameErr.set('This role name already exists');
                return false;
            }
        }
        isDisable.set(true);
        ApiHelper.post(
            APIURLConstants.POST_ROLES,
            state.attach(Downgraded).get()
        )
            .then((res) =>
            {
                if (res.data > 0)
                {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message:
                            state.roleID.get() > 0
                                ? 'Role updated successfully'
                                : 'Role added successfully',
                    });
                    state.set({
                        roleID: 0,
                        roleName: '',
                        eventID: 0,
                        status: 1,
                        createdBy: 0,
                    });
                    isDisable.set(false);
                    props.handleClose();
                    props.getRoles();
                } else
                {
                    // console.log('res else', res.data);
                    isDisable.set(false);
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Role name already exists',
                    });
                }
            })
            .catch((error) =>
            {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while adding role';
                }
                isDisable.set(false);
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
    };

    const resetState = () =>
    {
        state.set({
            roleID: 0,
            roleName: '',
            eventID: 0,
            status: 1,
            createdBy: 0,
        });
        props.handleClose();
    };
    return (
        <>
            <CustomDialog
                title={props.title}
                handleClose={resetState}
                open={props.open}
                fullWidth={true}
                maxWidth={'sm'}
                renderContent={renderDialogContent}
                renderActions={renderDialogActions}
                dialogContentClasses={{ root: classes.dialogContentRoot }}
            />
        </>
    );
};

export default RoleDialog;
